var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 5.503C3 3.568 4.518 2 6.39 2h11.22C19.481 2 21 3.568 21 5.503m-18 0c0 1.935 1.518 3.504 3.39 3.504h3.36M3 5.503V18.39C3 21.306 4.518 22 6.39 22h11.22c1.872 0 3.39-.694 3.39-3.61V5.503m0 0c0 1.935-1.518 3.504-3.39 3.504h-2.86m-5 0h5m-5 0V9m0 .007V10.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V9.007m0 0V9m.425-3a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2m1.367 9.43L8 14.944 9.546 19l6.444-1.15.01-4.439-2.114 1.327L11.803 13l-1.436 2.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBb);
export default __webpack_public_path__ + "static/media/services_bb.a1fe8aec8a6821a8ae4e322684b33270.svg";
export { ForwardRef as ReactComponent };